import { render, staticRenderFns } from "./LevelEditor.vue?vue&type=template&id=457c3eb8&scoped=true&"
import script from "./LevelEditor.vue?vue&type=script&lang=js&"
export * from "./LevelEditor.vue?vue&type=script&lang=js&"
import style0 from "./LevelEditor.vue?vue&type=style&index=0&id=457c3eb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "457c3eb8",
  null
  
)

export default component.exports